const wrapper = document.querySelector(".nav__wrapper");

document.addEventListener("alpine:init", () => {
    // set active class on current page
    let path = document.location.pathname;

    const searchLinksAndSetStates = (el) => {
        el.classList.remove("normal");
        if (el.dataset['isShortcut'] === '1') {
            return;
        }

        el.classList.add("active");

        document.querySelectorAll(".langnav .c-linkable").forEach((el) => {
            let countryCode = document.documentElement.getAttribute('lang') ?? '';
            if (countryCode && countryCode.indexOf("-") > -1) {
                countryCode = countryCode.split("-")[1];
            } else {
                countryCode = "";
            }

            let langCode = el.innerText.toLocaleLowerCase();
            if (!langCode) {
                return;
            }

            let langCountryCode = langCode + (countryCode ? "-" + countryCode : "");

            let hreflangEl = document.querySelector('link[rel="alternate"][hreflang="' + langCountryCode + '"]');
            if (!hreflangEl) {
                return;
            }

            let href = hreflangEl.getAttribute("href");
            if (href && href === document.location.origin + "/") {
                href += "de";
            }

            el.setAttribute("href", href);
        });

        if (el.closest(".mainnav-items__item")) {
            el.closest(".mainnav-items__item").classList.remove("normal");
            el.closest(".mainnav-items__item").classList.add("active");
        }
        if (
            el.closest("[x-data='mobileMenuItem']") &&
            el.closest("[x-data='mobileMenuItem']").querySelector("button.navitem")
        ) {
            el.closest("[x-data='mobileMenuItem']").querySelector("button.navitem").classList.remove("normal");
            el.closest("[x-data='mobileMenuItem']").querySelector("button.navitem").classList.add("active");
        }
        if (
            el.closest("[x-data='mobileMenuSubItem']") &&
            el.closest("[x-data='mobileMenuSubItem']").querySelector("button.navitem")
        ) {
            el.closest("[x-data='mobileMenuSubItem']").querySelector("button.navitem").classList.remove("normal");
            el.closest("[x-data='mobileMenuSubItem']").querySelector("button.navitem").classList.add("active");
        }
    };

    document.querySelectorAll('.nav a[href="' + path + '"]').forEach(searchLinksAndSetStates);

    while (path.length > 1) {
        path = path.substring(0, path.lastIndexOf("/"));
        document.querySelectorAll(".nav a[href='" + path + "']").forEach(searchLinksAndSetStates);
    }

    Alpine.data("navigation", () => ({
        scroll: 0,
        boxHeight: 0,
        down: false,
        mobileOpen: false,
        flyoutOpen: false,
        loaded: false,
        init() {
            this.loaded = true;
            this.boxHeight = document.querySelector(".mainnav-items__item:hover .mainnav-flyout")?.offsetHeight || 0;
            this.flyoutOpen = this.flyoutOpen || this.boxHeight > 0;
        },
        handleScroll: function () {
            const newScroll = window.scrollY;
            this.down = newScroll > 32 && this.scroll < newScroll;
            this.scroll = newScroll;
        },
        openMobileMenu() {
            if (this.mobileOpen) {
                this.$nextTick(() => {
                    this.$dispatch("close-mobile-menu");
                });
            }
            this.mobileOpen = !this.mobileOpen;
            document.documentElement.classList.toggle("xl:overflow-auto", this.mobileOpen);
            document.documentElement.classList.toggle("overflow-hidden", this.mobileOpen);
        },
        openDesktopFlyout(el) {
            this.flyoutOpen = true;
            this.$nextTick(() => {
                this.boxHeight = el.closest(".mainnav-items__item").querySelector(".mainnav-flyout").offsetHeight || 0;
            });
        },
        closeDesktopFlyout() {
            this.flyoutOpen = false;
            this.boxHeight = 0;
        },
        root: {
            ["x-bind:class"]() {
                return {
                    "shadow-nav": this.scroll > 32,
                    "js-is-top": this.scroll <= 32,
                    "js-hide-meta": this.down && this.scroll > 32,
                    "js-mobile-menu-open": this.mobileOpen,
                    "js-not-loaded": this.loaded === false,
                };
            },
            ["x-on:scroll.window.throttle.150ms"]() {
                this.handleScroll();
            },
            ["x-on:scroll.window.debounce"]() {
                this.handleScroll();
            },
            ["x-on:click.outside"]: "closeDesktopFlyout($event.target)",
        },
        box: {
            ["x-bind:style"]: "{height: boxHeight + 'px'}",
            ["x-show"]: "flyoutOpen",
            ["x-transition:enter"]: "transition-all",
            ["x-transition:leave"]: "transition-all",
        },
        mainli: (children) =>
            children
                ? {
                      ["x-on:mouseenter"]: "openDesktopFlyout($event.target)",
                      ["x-on:mouseleave"]: "closeDesktopFlyout($event.target)",
                      ["x-on:keydown.escape"]: "closeDesktopFlyout($event.target)",
                  }
                : {},
    }));

    Alpine.data("mobileMenu", () => ({
        menuItemOpen: false,
        toggleMenuItem() {
            this.menuItemOpen = !this.menuItemOpen;
            wrapper.scrollTop = 0;
        },
        reset() {
            this.menuItemOpen = false;
        },
        mobileMenu: {
            ["x-on:close-mobile-menu.window"]: "reset()",
            [":class"]: "{'shifted': menuItemOpen}",
        },
    }));

    Alpine.data("mobileMenuItem", () => ({
        currentItemOpen: false,
        subItemOpen: false,
        toggleCurrentItem() {
            this.currentItemOpen = !this.currentItemOpen;
            wrapper.scrollTop = 0;
        },
        toggleSubItem() {
            this.subItemOpen = !this.subItemOpen;
            wrapper.scrollTop = 0;
        },
        reset() {
            this.currentItemOpen = false;
            this.subItemOpen = false;
        },
        mobileMenuItem: {
            ["x-on:close-mobile-menu.window"]: "reset()",
        },
    }));

    Alpine.data("mobileMenuSubItem", () => ({
        currentSubItemOpen: false,
        toggleCurrentSubItem() {
            this.currentSubItemOpen = !this.currentSubItemOpen;
            wrapper.scrollTop = 0;
        },
        reset() {
            this.currentSubItemOpen = false;
        },
        mobileMenuSubItem: {
            ["x-on:close-mobile-menu.window"]: "reset()",
        },
    }));
});
